import script from "./setIdentity.vue?vue&type=script&setup=true&lang=js"
export * from "./setIdentity.vue?vue&type=script&setup=true&lang=js"

import "./setIdentity.vue?vue&type=style&index=0&id=223811b3&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223811b3"]])

export default __exports__